<div class="flex flex-col h-full p-6 items-start">
  <!-- Less gap under the logo on phones so the whole menu (down to «Chat») fits. -->
  @if (showLogo) {
    <div class="h-auto w-32 pb-4 md:pb-6 block justify-center pt-0">
      <a routerLink="/" (click)="navigate()">
        <img src="./assets/logo.svg" alt="Logo" />
      </a>
    </div>
  }
  <!-- Grow to push the account area down, but never shrink below the menu's height:
       on short viewports (e.g. Chrome iOS) the list would otherwise overflow onto it. -->
  <div class="flex-[1_0_auto] w-full min-w-0">
    <mat-nav-list aria-label="Hauptnavigation">
      @if (userRole === 'schulgemeinde') {
        <!-- ========== SCHULGEMEINDE VIEW ========== -->
        <a
          mat-list-item
          (click)="navigate()"
          routerLink="/"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="h-11"
          matTooltip="Startseite"
          matTooltipPosition="after"
          [matTooltipDisabled]="showTooltips()">
          <div class="dashboard-nav-row">
            <img
              src="./assets/dashboard/dashboard-home.svg"
              alt=""
              class="h-4 w-6 object-contain shrink-0"
              height="16" />
            <div class="pl-4 leading-none block font-bold">Startseite</div>
          </div>
        </a>

        <a
          mat-list-item
          (click)="navigate()"
          routerLink="/profile"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="h-11"
          matTooltip="Fachkräfte finden"
          matTooltipPosition="after"
          [matTooltipDisabled]="showTooltips()">
          <div class="dashboard-nav-row">
            <img
              src="./assets/dashboard/dashboard-network.svg"
              alt=""
              class="h-4 w-6 object-contain shrink-0"
              height="16" />
            <div class="pl-4 leading-none block font-bold">
              Fachkräfte finden
            </div>
          </div>
        </a>

        <a
          mat-list-item
          (click)="navigate()"
          routerLink="/schools"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="h-11"
          matTooltip="Schulen"
          matTooltipPosition="after"
          [matTooltipDisabled]="showTooltips()">
          <div class="dashboard-nav-row">
            <img
              src="./assets/dashboard/dashboard-schools.svg"
              alt=""
              class="h-4 w-6 object-contain shrink-0"
              height="16" />
            <div class="pl-4 leading-none block font-bold">Schulen</div>
          </div>
        </a>

        <a
          mat-list-item
          (click)="navigate()"
          routerLink="/jobs"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="h-11"
          matTooltip="Stellen"
          matTooltipPosition="after"
          [matTooltipDisabled]="showTooltips()">
          <div class="dashboard-nav-row">
            <img
              src="./assets/dashboard/dashboard-jobs.svg"
              alt=""
              class="h-4 w-6 object-contain shrink-0"
              height="16" />
            <div class="pl-4 leading-none block font-bold">Stellen</div>
          </div>
        </a>

        <div class="relative">
          <a
            mat-list-item
            (click)="navigate()"
            routerLink="/chat"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
            class="h-11"
            matTooltip="Chat"
            matTooltipPosition="after"
            [matTooltipDisabled]="showTooltips()">
            <div class="flex justify-between items-center">
              <div class="dashboard-nav-row min-w-0 flex-1">
                <img
                  src="./assets/dashboard/dashboard-msg.svg"
                  alt=""
                  class="h-4 w-6 object-contain shrink-0"
                  height="16" />
                <div class="pl-4 leading-none block font-bold">Chat</div>
              </div>
              @if (unreadMessageCount > 0) {
                <span class="unread-message-count">
                  <span class="truncate">{{ unreadMessageCount }}</span>
                </span>
              }
            </div>
          </a>
        </div>

        <div class="pt-2 pb-2">
          <mat-divider></mat-divider>
        </div>

        @if (
          !contextResolving && (schools.length > 0 || authorities.length > 0)
        ) {
          <div class="w-full pt-2 pb-2">
            <app-navbar-entity-switcher-primary
              [schools]="schools"
              [authorities]="authorities"
              [selectedEntityValue]="selectedEntityValue"
              [(dropdownOpen)]="entityDropdownOpen"
              (entitySelected)="onEntityChange($event)" />
          </div>
        }

        @if (schulgemeindeShowsMeineSchulenNav) {
          @if (selectedSchoolUnitId && schoolCapabilitiesSettled) {
            @if (showSchoolJobsLink) {
              <a
                mat-list-item
                (click)="navigate()"
                [routerLink]="['/my-schools', selectedSchoolUnitId, 'jobs']"
                [class.active]="isJobsRoute"
                class="h-11"
                matTooltip="Inserate & Bewerbungen"
                matTooltipPosition="after"
                [matTooltipDisabled]="showTooltips()">
                <div class="flex justify-between items-center gap-2">
                  <div class="flex self-center items-center min-w-0 flex-1">
                    <span
                      aria-hidden="true"
                      class="notranslate inline-flex shrink-0">
                      <mat-icon
                        class="material-symbols-rounded"
                        aria-hidden="true"
                        data-mat-icon-type="font"
                        >description</mat-icon
                      >
                    </span>
                    <div
                      class="pl-4 leading-none py-0.5 block font-bold min-w-0 truncate">
                      Inserate &amp; Bewerbungen
                    </div>
                  </div>
                  @if (unreadApplicationCount() > 0) {
                    <span class="unread-message-count shrink-0">
                      <span class="truncate">{{
                        unreadApplicationCount()
                      }}</span>
                    </span>
                  }
                </div>
              </a>
            }

            @if (showSchoolStructureLink) {
              <a
                mat-list-item
                (click)="navigate()"
                [routerLink]="[
                  '/my-schools',
                  selectedSchoolUnitId,
                  'structure'
                ]"
                routerLinkActive="active"
                ariaCurrentWhenActive="page"
                [routerLinkActiveOptions]="{ exact: true }"
                class="h-11"
                matTooltip="Strukturverwaltung"
                matTooltipPosition="after"
                [matTooltipDisabled]="showTooltips()">
                <div class="flex items-center self-center">
                  <mat-icon
                    class="material-symbols-rounded"
                    aria-hidden="true"
                    data-mat-icon-type="font"
                    >account_tree</mat-icon
                  >
                  <div class="pl-4 leading-none block font-bold">
                    Strukturverwaltung
                  </div>
                </div>
              </a>
            }

            @if (showSchoolProfileLink) {
              <a
                mat-list-item
                (click)="navigate()"
                [routerLink]="[
                  '/my-schools',
                  selectedSchoolUnitId,
                  'schools',
                  selectedSchoolUnitId
                ]"
                [class.active]="isMySchoolProfileRoute"
                class="h-11"
                matTooltip="Profil & Auftritt"
                matTooltipPosition="after"
                [matTooltipDisabled]="showTooltips()">
                <div class="flex items-center self-center">
                  <mat-icon
                    class="material-symbols-rounded"
                    aria-hidden="true"
                    data-mat-icon-type="font"
                    >school</mat-icon
                  >
                  <div class="pl-4 leading-none block font-bold">
                    Profil &amp; Auftritt
                  </div>
                </div>
              </a>
            }
          }
        } @else {
          @if (activeAuthorityId && !contextResolving) {
            @if (showJobsLink) {
              <a
                mat-list-item
                href="#"
                (click)="openSchulgemeindeHrJobs($event)"
                [class.active]="isJobsRoute"
                class="h-11"
                matTooltip="Inserate & Bewerbungen"
                matTooltipPosition="after"
                [matTooltipDisabled]="showTooltips()">
                <div class="flex justify-between items-center gap-2">
                  <div class="flex self-center items-center min-w-0 flex-1">
                    <span
                      aria-hidden="true"
                      class="notranslate inline-flex shrink-0">
                      <mat-icon
                        class="material-symbols-rounded"
                        aria-hidden="true"
                        data-mat-icon-type="font"
                        >description</mat-icon
                      >
                    </span>
                    <div
                      class="pl-4 leading-none py-0.5 block font-bold min-w-0 truncate">
                      Inserate &amp; Bewerbungen
                    </div>
                  </div>
                  @if (unreadApplicationCount() > 0) {
                    <span class="unread-message-count shrink-0">
                      <span class="truncate">{{
                        unreadApplicationCount()
                      }}</span>
                    </span>
                  }
                </div>
              </a>
            }

            @if (showStructureLink) {
              <a
                mat-list-item
                (click)="navigate()"
                [routerLink]="[
                  '/my-organization',
                  activeAuthorityId,
                  'structure'
                ]"
                routerLinkActive="active"
                ariaCurrentWhenActive="page"
                [routerLinkActiveOptions]="{ exact: true }"
                class="h-11"
                matTooltip="Strukturverwaltung"
                matTooltipPosition="after"
                [matTooltipDisabled]="showTooltips()">
                <div class="flex items-center self-center">
                  <mat-icon
                    class="material-symbols-rounded"
                    aria-hidden="true"
                    data-mat-icon-type="font"
                    >account_tree</mat-icon
                  >
                  <div class="pl-4 leading-none block font-bold">
                    Strukturverwaltung
                  </div>
                </div>
              </a>
            }

            @if (showProfileLink) {
              <a
                mat-list-item
                (click)="navigate()"
                [routerLink]="['/my-organization', activeAuthorityId]"
                [class.active]="isOrgProfileRoute"
                class="h-11"
                matTooltip="Profil & Auftritt"
                matTooltipPosition="after"
                [matTooltipDisabled]="showTooltips()">
                <div class="flex items-center self-center">
                  <mat-icon
                    class="material-symbols-rounded"
                    aria-hidden="true"
                    data-mat-icon-type="font"
                    >school</mat-icon
                  >
                  <div class="pl-4 leading-none block font-bold">
                    Profil &amp; Auftritt
                  </div>
                </div>
              </a>
            }
          }
        }
      } @else if (userRole === 'schuleinheit') {
        <!-- ========== SCHULEINHEIT VIEW ========== -->
        <a
          mat-list-item
          (click)="navigate()"
          routerLink="/"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="h-11"
          matTooltip="Startseite"
          matTooltipPosition="after"
          [matTooltipDisabled]="showTooltips()">
          <div class="dashboard-nav-row">
            <img
              src="./assets/dashboard/dashboard-home.svg"
              alt=""
              class="h-4 w-6 object-contain shrink-0"
              height="16" />
            <div class="pl-4 leading-none block font-bold">Startseite</div>
          </div>
        </a>

        <a
          mat-list-item
          (click)="navigate()"
          routerLink="/profile"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="h-11"
          matTooltip="Fachkräfte finden"
          matTooltipPosition="after"
          [matTooltipDisabled]="showTooltips()">
          <div class="dashboard-nav-row">
            <img
              src="./assets/dashboard/dashboard-network.svg"
              alt=""
              class="h-4 w-6 object-contain shrink-0"
              height="16" />
            <div class="pl-4 leading-none block font-bold">
              Fachkräfte finden
            </div>
          </div>
        </a>

        <a
          mat-list-item
          (click)="navigate()"
          routerLink="/schools"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="h-11"
          matTooltip="Schulen"
          matTooltipPosition="after"
          [matTooltipDisabled]="showTooltips()">
          <div class="dashboard-nav-row">
            <img
              src="./assets/dashboard/dashboard-schools.svg"
              alt=""
              class="h-4 w-6 object-contain shrink-0"
              height="16" />
            <div class="pl-4 leading-none block font-bold">Schulen</div>
          </div>
        </a>

        <a
          mat-list-item
          (click)="navigate()"
          routerLink="/jobs"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="h-11"
          matTooltip="Stellen"
          matTooltipPosition="after"
          [matTooltipDisabled]="showTooltips()">
          <div class="dashboard-nav-row">
            <img
              src="./assets/dashboard/dashboard-jobs.svg"
              alt=""
              class="h-4 w-6 object-contain shrink-0"
              height="16" />
            <div class="pl-4 leading-none block font-bold">Stellen</div>
          </div>
        </a>

        <div class="relative">
          <a
            mat-list-item
            (click)="navigate()"
            routerLink="/chat"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
            class="h-11"
            matTooltip="Chat"
            matTooltipPosition="after"
            [matTooltipDisabled]="showTooltips()">
            <div class="flex justify-between items-center">
              <div class="dashboard-nav-row min-w-0 flex-1">
                <img
                  src="./assets/dashboard/dashboard-msg.svg"
                  alt=""
                  class="h-4 w-6 object-contain shrink-0"
                  height="16" />
                <div class="pl-4 leading-none block font-bold">Chat</div>
              </div>
              @if (unreadMessageCount > 0) {
                <span class="unread-message-count">
                  <span class="truncate">{{ unreadMessageCount }}</span>
                </span>
              }
            </div>
          </a>
        </div>

        <div class="pt-2 pb-2">
          <mat-divider></mat-divider>
        </div>

        @if (
          !contextResolving && (schools.length > 0 || authorities.length > 0)
        ) {
          <div class="w-full pt-2 pb-2">
            <app-navbar-entity-switcher-primary
              [schools]="schools"
              [authorities]="authorities"
              [selectedEntityValue]="selectedEntityValue"
              [(dropdownOpen)]="entityDropdownOpen"
              (entitySelected)="onEntityChange($event)" />
          </div>
        }

        @if (activeSchoolId && schoolCapabilitiesSettled && !contextResolving) {
          @if (showSchoolJobsLink) {
            <a
              mat-list-item
              (click)="navigate()"
              [routerLink]="['/my-schools', activeSchoolId, 'jobs']"
              [class.active]="isJobsRoute"
              class="h-11"
              matTooltip="Inserate & Bewerbungen"
              matTooltipPosition="after"
              [matTooltipDisabled]="showTooltips()">
              <div class="flex justify-between items-center gap-2">
                <div class="flex self-center items-center min-w-0 flex-1">
                  <span
                    aria-hidden="true"
                    class="notranslate inline-flex shrink-0">
                    <mat-icon
                      class="material-symbols-rounded"
                      aria-hidden="true"
                      data-mat-icon-type="font"
                      >description</mat-icon
                    >
                  </span>
                  <div
                    class="pl-4 leading-none py-0.5 block font-bold min-w-0 truncate">
                    Inserate &amp; Bewerbungen
                  </div>
                </div>
                @if (unreadApplicationCount() > 0) {
                  <span class="unread-message-count shrink-0">
                    <span class="truncate">{{ unreadApplicationCount() }}</span>
                  </span>
                }
              </div>
            </a>
          }

          @if (showSchoolStructureLink) {
            <a
              mat-list-item
              (click)="navigate()"
              [routerLink]="['/my-schools', activeSchoolId, 'structure']"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
              [routerLinkActiveOptions]="{ exact: true }"
              class="h-11"
              matTooltip="Strukturverwaltung"
              matTooltipPosition="after"
              [matTooltipDisabled]="showTooltips()">
              <div class="flex items-center self-center">
                <mat-icon
                  class="material-symbols-rounded"
                  aria-hidden="true"
                  data-mat-icon-type="font"
                  >account_tree</mat-icon
                >
                <div class="pl-4 leading-none block font-bold">
                  Strukturverwaltung
                </div>
              </div>
            </a>
          }

          @if (showSchoolProfileLink) {
            <a
              mat-list-item
              (click)="navigate()"
              [routerLink]="[
                '/my-schools',
                activeSchoolId,
                'schools',
                activeSchoolId
              ]"
              [class.active]="isMySchoolProfileRoute"
              class="h-11"
              matTooltip="Profil & Auftritt"
              matTooltipPosition="after"
              [matTooltipDisabled]="showTooltips()">
              <div class="flex items-center self-center">
                <mat-icon
                  class="material-symbols-rounded"
                  aria-hidden="true"
                  data-mat-icon-type="font"
                  >school</mat-icon
                >
                <div class="pl-4 leading-none block font-bold">
                  Profil &amp; Auftritt
                </div>
              </div>
            </a>
          }
        }
      } @else {
        <!-- ========== FACHKRAFT VIEW ========== -->
        <a
          mat-list-item
          (click)="navigate()"
          routerLink="/"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="h-11"
          matTooltip="Startseite"
          matTooltipPosition="after"
          [matTooltipDisabled]="showTooltips()">
          <div class="dashboard-nav-row">
            <img
              src="./assets/dashboard/dashboard-home.svg"
              alt=""
              class="h-4 w-6 object-contain shrink-0"
              height="16" />
            <div class="pl-4 leading-none block font-bold">Startseite</div>
          </div>
        </a>

        <!-- Offene Stellen with its sub-items always visible (like Meine Bewerbungen / Bewerbungsdossier) -->
        <a
          mat-list-item
          (click)="navigate()"
          routerLink="/jobs"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="h-11"
          matTooltip="Offene Stellen"
          matTooltipPosition="after"
          [matTooltipDisabled]="showTooltips()">
          <div class="dashboard-nav-row">
            <img
              src="./assets/dashboard/dashboard-jobs.svg"
              alt=""
              class="h-4 w-6 object-contain shrink-0"
              height="16" />
            <div class="pl-4 leading-none block font-bold">Offene Stellen</div>
          </div>
        </a>

        <div class="pl-4">
          <a
            mat-list-item
            (click)="navigate()"
            routerLink="/search-agent"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
            class="h-11"
            matTooltip="Stellenabo"
            matTooltipPosition="after"
            [matTooltipDisabled]="showTooltips()">
            <div class="flex items-center self-center">
              <mat-icon class="material-symbols-rounded" aria-hidden="true"
                >notifications_active</mat-icon
              >
              <div class="pl-4 leading-none block font-bold">Stellenabo</div>
            </div>
          </a>

          <a
            mat-list-item
            (click)="navigate()"
            routerLink="/stellenchats"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
            class="h-11"
            matTooltip="Stellenchats"
            matTooltipPosition="after"
            [matTooltipDisabled]="showTooltips()">
            <div class="flex items-center self-center">
              <mat-icon class="material-symbols-rounded" aria-hidden="true"
                >forum</mat-icon
              >
              <div class="pl-4 leading-none block font-bold">Stellenchats</div>
            </div>
          </a>
        </div>

        <a
          mat-list-item
          (click)="navigate()"
          routerLink="/applications/my"
          routerLinkActive
          #bewerbungenRla="routerLinkActive"
          [class.active]="
            bewerbungenRla.isActive && !isApplicationDocumentsRoute
          "
          class="h-11"
          matTooltip="Meine Bewerbungen"
          matTooltipPosition="after"
          [matTooltipDisabled]="showTooltips()">
          <div class="dashboard-nav-row">
            <!-- Filled like the other main items' icons (their SVGs are solid),
                 not only when active. -->
            <mat-icon
              class="material-symbols-rounded shrink-0 !w-6 !h-5 !text-[22px] leading-5 flex items-center justify-center [font-variation-settings:'FILL'_1,'wght'_400,'GRAD'_0,'opsz'_48]"
              aria-hidden="true"
              >assignment</mat-icon
            >
            <div class="pl-4 leading-none block font-bold">
              Meine Bewerbungen
            </div>
          </div>
        </a>

        <!-- Always visible (not collapsible). -->
        <div class="pl-4">
          <a
            mat-list-item
            (click)="navigate()"
            routerLink="/applications/my/documents"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
            class="h-11"
            matTooltip="Bewerbungsdossier"
            matTooltipPosition="after"
            [matTooltipDisabled]="showTooltips()">
            <div class="flex items-center self-center">
              <mat-icon class="material-symbols-rounded" aria-hidden="true"
                >folder_open</mat-icon
              >
              <div class="pl-4 leading-none block font-bold">
                Bewerbungsdossier
              </div>
            </div>
          </a>
        </div>

        <a
          mat-list-item
          (click)="navigate()"
          routerLink="/schools"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="h-11"
          matTooltip="Schulen"
          matTooltipPosition="after"
          [matTooltipDisabled]="showTooltips()">
          <div class="dashboard-nav-row">
            <img
              src="./assets/dashboard/dashboard-schools.svg"
              alt=""
              class="h-4 w-6 object-contain shrink-0"
              height="16" />
            <div class="pl-4 leading-none block font-bold">Schulen</div>
          </div>
        </a>

        <a
          mat-list-item
          (click)="navigate()"
          routerLink="/profile"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="h-11"
          matTooltip="Fachkräfte-Netzwerk"
          matTooltipPosition="after"
          [matTooltipDisabled]="showTooltips()">
          <div class="dashboard-nav-row">
            <img
              src="./assets/dashboard/dashboard-network.svg"
              alt=""
              class="h-4 w-6 object-contain shrink-0"
              height="16" />
            <div class="pl-4 leading-none block font-bold">
              Fachkräfte-Netzwerk
            </div>
          </div>
        </a>

        <div class="relative">
          <a
            mat-list-item
            (click)="navigate()"
            routerLink="/chat"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
            class="h-11"
            matTooltip="Chat"
            matTooltipPosition="after"
            [matTooltipDisabled]="showTooltips()">
            <div class="flex justify-between items-center">
              <div class="dashboard-nav-row min-w-0 flex-1">
                <img
                  src="./assets/dashboard/dashboard-msg.svg"
                  alt=""
                  class="h-4 w-6 object-contain shrink-0"
                  height="16" />
                <div class="pl-4 leading-none block font-bold">Chat</div>
              </div>
              @if (unreadMessageCount > 0) {
                <span class="unread-message-count">
                  <span class="truncate">{{ unreadMessageCount }}</span>
                </span>
              }
            </div>
          </a>
        </div>

        <div class="pt-2 pb-2">
          <mat-divider></mat-divider>
        </div>
      }

      @if (isStaff()) {
        <a
          mat-list-item
          (click)="navigate()"
          routerLink="/admin/deals"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          class="h-11"
          matTooltip="Vertrieb"
          matTooltipPosition="after"
          [matTooltipDisabled]="showTooltips()">
          <div class="flex items-center self-center">
            <mat-icon
              class="material-symbols-rounded"
              aria-hidden="true"
              data-mat-icon-type="font"
              >handshake</mat-icon
            >
            <div class="pl-4 leading-none block font-bold">Vertrieb</div>
          </div>
        </a>
      }
    </mat-nav-list>
  </div>

  <div class="w-full min-w-0 pt-4 flex flex-col gap-3">
    @if (showSchuleinheitPaidUpgradeInSidebar()) {
      <button
        mat-stroked-button
        type="button"
        class="w-full"
        (click)="openSchuleinheitPaidUpgradeDialog($event)">
        <mat-icon class="material-symbols-rounded">upgrade</mat-icon>
        Schuleinheitsabo-Upgrade
      </button>
    }
    @if (
      roleService.loaded &&
      userRole === 'fachkraft' &&
      schools.length === 0 &&
      authorities.length === 0
    ) {
      <button
        mat-stroked-button
        type="button"
        class="w-full"
        (click)="openUpgradeDialog($event)">
        <mat-icon class="material-symbols-rounded">upgrade</mat-icon>
        Upgrade auf Schul-Account
      </button>
    }
    <nav aria-label="Konto">
      <button
        type="button"
        class="nav-account-trigger"
        [class.is-active]="isAccountRoute"
        [matMenuTriggerFor]="accountMenu">
        <app-round-image
          size="60"
          [title]="$safeNavigationMigration(profile?.name)"
          [description]="getJobTitle()"
          [src]="getAvatarUrl(profile)"
          class="min-w-0 flex-1"></app-round-image>
        <span class="sr-only"
          >Konto-Menü: Mein Profil, Einstellungen, Ausloggen</span
        >
        @if (logoutInProgress) {
          <mat-spinner diameter="20" class="shrink-0 mr-2" />
        } @else {
          <mat-icon class="material-symbols-rounded shrink-0" aria-hidden="true"
            >unfold_more</mat-icon
          >
        }
      </button>
      <mat-menu #accountMenu="matMenu" yPosition="above" xPosition="after">
        <a
          mat-menu-item
          (click)="navigate()"
          [routerLink]="['/me', $safeNavigationMigration(profile?.id)]">
          <mat-icon class="material-symbols-rounded">person</mat-icon>
          Mein Profil
        </a>
        <a mat-menu-item (click)="navigate()" routerLink="/settings">
          <mat-icon class="material-symbols-rounded">settings</mat-icon>
          Einstellungen
        </a>
        <button
          mat-menu-item
          type="button"
          (click)="logout()"
          [disabled]="logoutInProgress">
          <mat-icon class="material-symbols-rounded">logout</mat-icon>
          Ausloggen
        </button>
      </mat-menu>
    </nav>
  </div>
</div>
